import { render, staticRenderFns } from "./wallet-table.vue?vue&type=template&id=d7459de4&"
import script from "./wallet-table.vue?vue&type=script&lang=js&"
export * from "./wallet-table.vue?vue&type=script&lang=js&"
import style0 from "./wallet-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
